import { render, staticRenderFns } from "./paperLooks.vue?vue&type=template&id=6bf5434b&scoped=true&"
import script from "./paperLooks.vue?vue&type=script&lang=js&"
export * from "./paperLooks.vue?vue&type=script&lang=js&"
import style0 from "./paperLooks.vue?vue&type=style&index=0&id=6bf5434b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf5434b",
  null
  
)

export default component.exports